const getters = {
  cart(state) {
    return state.cart;
  },
};

export default getters;
